import Section from "@/components/ui/section";
import React from "react";
import { m } from "framer-motion";
export default function Banner() {
  return (
    <Section className="bg-[#fafafa]">
      <m.div
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 100 }}
        transition={{ duration: 0.75 }}
        className="flex flex-col items-center w-full mt-20"
      >
        <p className="text-[#333333] uppercase">Some Subheading Here</p>
        <h1 className="text-blue font-semibold text-center heading">
          <span className="text-lightBlue">Our Services</span> Redefined
        </h1>
        <p className="text-center lg:max-w-[600px] !leading-normal mt-4">
          SoulScale provides a comprehensive and diverse range of impact-driven
          and sustainable solutions to drive your organisation&apos;s success.
          Our dedicated team of experts offers specialised services catering to
          your specific needs.{" "}
        </p>
      </m.div>
    </Section>
  );
}
